var bus = require('../bus');

module.exports = function() {

  this.opts.customFilters.forEach(function(filter) {
    bus.$on('vue-tables.filter::' + filter.name, function(value) {
      this.customQueries[filter.name] = value;
      this.setPage(1);
      this.search(this.data);
    }.bind(this));

  }.bind(this))

}



// WEBPACK FOOTER //
// ./~/vue-tables-2/lib/methods/register-client-filters.js